module.exports = __webpack_public_path__ + "img/goal_m01-1.a084f801.jpg";